import React from 'react';
import { Input, Button, Dropdown, Grid, Header } from 'semantic-ui-react';
import Checkbox from '@material-ui/core/Checkbox';
import Loading from '../../loadings';
import $ from "jquery";
import Server from '../../../functions/server';
import ReadCookie from '../../../functions/readcookies';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

class OtherCharge extends React.Component {

  state = {
    selectedType: 'Purchaser', data: [], customer: []
  }

  componentDidMount() {
    this.getPurchaser();
  }

  getPurchaser() {
    let context = this;
    let cook = (ReadCookie("vaigai"));
    let userId = cook.id;
    this.setState({ load: true, message: 'Getting Purchaser Details!!!!' });
    $.ajax({
      type: 'POST',
      data: { 'userId': userId, 'where': 'Purchase-Detail' },
      url: Server() + 'purchaser/getpurchaser2.php',
      success: function(data) {
        let purchaseState;
        try {
          data = JSON.parse(data);
          context.getCustomer(data);
        } catch (e) { alert('Error To Get Purchaser!!!') }
      },
      error: function(err) {
        context.setState({ load: false, });
        alert('Try again!!!!')
      }
    });
  }

  getCustomer(data) {
    let context = this;
    $.ajax({
      type: 'POST',
      url: Server() + 'customer/getallcustomer.php',
      success: function(customer) {
        try {
          customer = JSON.parse(customer);
          context.setState({ data, customer, load: false })
        } catch (e) { alert('Error To Get Customer!!!'); context.setState({ load: false }) }
      },
      error: function(err) {
        context.setState({ load: false, });
        alert('Try again!!!!')
      }
    });
  }

  getCustomerDropdown() {
    let option = [];
    try {
      this.state.customer.map((c) => {
        option.push({ key: c.id+'->'+c.name+'->'+c.mobile, text: c.id+'->'+c.name+'->'+c.mobile, value: c.id })
      })
    } catch (e) {
    }
    return option;
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  }

  handleCheckBox = name => event => {
    if (event.target.checked) {
      this.setState({ selectedType: 'Customer', dropdown: '', selectedPurchaser: '', check: true, gstn: '', state: '' })
    }
    else {
      this.setState({ selectedType: 'Purchaser', dropdown: '', selectedPurchaser: '', check: false, gstn: '', state: '' })
    }
  }

  purchaser = event => {
    let val = event.target.value;
    let value = val.split('->')[0];
    let state = val.split('->')[2];
    let gstn, address_id, name;
    this.state.data.map((y) => {
      if (y.id == value) {
        gstn = y.gstn;
        address_id = y.address_id;
        name = y.name;
      }
    })
    this.setState({ selectedPurchaser: value, name, state: state, gstn: gstn, dropdown: event.target.value, address_id })
    this.props.upDateState(state);
  };

  customer = event => {
    let val = event.target.value;
    let value = val.split('->')[0];
    let data = this.state.customer;
    let state, gstn, name;
    data.map((z) => {
      if (z.id == value) { state = z.state; gstn = z.GSTIN; name = z.name; }
    })
    this.setState({ selectedPurchaser: value, name, state: state, gstn: gstn, dropdown: event.target.value, address_id: value })
  }

  getData() {
    if (!this.props.menuPermission.edit) {
      alert('You Are Not Allow To Edit!!!');
      return;
    }
    let invoice, invoice_date, address_id, type, gstn, state, dropdown, purchaser_id, name;
    this.props.data.map((c) => {
      if (c.id == this.props.id) {
        invoice = c.invoice_no;
        invoice_date = c.invoice_date.split(' ')[0];
        address_id = c.purchaser_address_id;
        type = c.type; gstn = c.gstn; state = c.state;
        dropdown = c.purchaser+'->'+c.gstn+'->'+c.state;
        purchaser_id = c.purchaser_id;
        name = c.purchaser;
      }
    })

    if (type == 'Customer') {
      let data = this.state.customer;
      data.map((z) => {
        if (z.id == purchaser_id) { state = z.state; gstn = z.GSTIN; dropdown = z.name+'->'+z.state+'->'+z.GSTIN }
      })
      this.setState({ dialog: true, dropdown, gstn, state, invoice,
        invoice_date, address_id, name, selectedPurchaser: purchaser_id, selectedType: type, check: true })
    }
    else {
      this.setState({ dialog: true, dropdown, gstn, state, invoice,
        invoice_date, address_id, name, selectedPurchaser: purchaser_id, selectedType: type, check: false })
    }
  }

  submit() {
    let context = this;
    this.setState({ load: true, message: 'Update Master Details!!!' });
    $.ajax({
      type: 'POST',
      data: { 'address_id': context.state.address_id, 'purchaser_id': context.state.selectedPurchaser,
              'invoice': context.state.invoice, 'invoice_date': context.state.invoice_date,
              'purchase_id': context.props.id, 'selectedType': context.state.selectedType },
      url: Server() + 'purchasedetail/editmasterDetails.php',
      success: function(data) {
        let datas = context.props.data;
        if (data == 1) {
          context.setState({ dialog: false, load: false })
          datas.map((c) => {
            if (c.id == context.props.id) {
              c.purchaser_address_id = context.state.address_id;
              c.invoice_no = context.state.invoice;
              c.purchaser = context.state.name;
              c.state = context.state.state;
              c.gstn = context.state.gstn;
              c.purchaser_id = context.state.selectedPurchaser;
              c.type = context.state.selectedType;
              c.invoice_date = context.state.invoice_date;
            }
          })
          context.props.updateData(datas);
        }
        else {
          context.setState({ load: false })
        }
      },
      error: function(err) {
        context.setState({ load: false, });
        alert('Try again!!!!')
      }
    });
  }


  render() {
    return (
      <div>
        <div onClick={this.getData.bind(this)}>Edit</div>
        <Loading load={this.state.load} message={this.state.message} />
        <Dialog fullWidth={this.state.fullWidth} maxWidth={this.state.maxWidth}
          open={this.state.dialog} aria-labelledby="max-width-dialog-title">
          <DialogTitle id="max-width-dialog-title">Edit Master Data</DialogTitle>
          <DialogContent>
            <Grid>
              <Grid.Column mobile={16} tablet={16} computer={16}>
                <Checkbox checked={this.state.check} onChange={this.handleCheckBox('Customer')}
                  value="Check" /> Purchase from Customer
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={16}>
                { this.state.selectedType == 'Purchaser' ?
                  (
                    <div>
                      Select Purchaser
                      <datalist id="suggestionPurchaser">
                          {this.state.data.map((y) => {
                            return (
                              <option id='box'>{y.id + '->' + y.name+ '->' + y.state}</option>
                            )
                          })}
                      </datalist>
                      <input style={{height: 35, width: '100%'}} onChange={this.purchaser} autoComplete="on"
                      list="suggestionPurchaser" value={this.state.dropdown} />
                    </div>
                  ):
                  (
                    <div>
                      Select Customer
                      <datalist id="suggestions">
                          {this.state.customer.map((y) => {
                            return (
                              <option id='box'>{y.id + '->' + y.name+ '->' + y.state}</option>
                            )
                          })}
                      </datalist>
                      <input style={{height: 35, width: '100%'}} onChange={this.customer} autoComplete="on"
                      list="suggestions" value={this.state.dropdown} />
                    </div>
                  )
                }
                <Grid>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    <div>{"GSTIN: "+this.state.gstn}</div>
                  </Grid.Column>
                  <Grid.Column mobile={16} tablet={16} computer={8}>
                    <div>{"State: "+this.state.state}</div>
                  </Grid.Column>
                </Grid>
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}> Invoice<br/>
                <Input onChange={this.handleChange('invoice')} value={this.state.invoice} fluid focus />
              </Grid.Column>
              <Grid.Column mobile={16} tablet={16} computer={8}> Invoice Date<br/>
                <input type="date" id="date" value={this.state.invoice_date}
                  style={{width: '100%', height: 35 }} onChange={this.handleChange('invoice_date')} />
              </Grid.Column>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => { this.setState({ dialog: false }) }}>Cancel</Button>
            <Button onClick={this.submit.bind(this)}>Submit</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default OtherCharge;
